import { render, staticRenderFns } from "./cloud-sign-in.vue?vue&type=template&id=3fede612&scoped=true&"
import script from "./cloud-sign-in.vue?vue&type=script&lang=js&"
export * from "./cloud-sign-in.vue?vue&type=script&lang=js&"
import style0 from "./cloud-sign-in.vue?vue&type=style&index=0&id=3fede612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fede612",
  null
  
)

export default component.exports